module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/134-liechtenstein-c662269f464374755e995c6d65be8118.svg";